export class FormHelpdeskCode
{
	static COMPILATION_FACEBOOK: number = 13856526;
	static COMMON_COMPILATION: number = 13841876;
}